// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

// ⚠️ Replace these with your actual Firebase project config
export const firebaseConfig = {
    apiKey: "AIzaSyDfnNrzc5TJSjkVSr6ueoP65RINp3-6XCE",
    authDomain: "nodom-3c1ac.firebaseapp.com",
    projectId: "nodom-3c1ac",
    storageBucket: "nodom-3c1ac.firebasestorage.app",
    messagingSenderId: "636253149077",
    appId: "1:636253149077:web:ba79905d1e600ac0ed889c",
    measurementId: "G-JZVXCVJD5G"
  };

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app);

// Secondary app for Admin to create doctors without logging out
const secondaryApp = initializeApp(firebaseConfig, "Secondary");
export const secondaryAuth = getAuth(secondaryApp);

export default app;
